<template>
    <div>
        <PageHeader :title="pageHeader">
            <template v-slot:icon>
                <svg class="page-header-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                </svg>
            </template>
        </PageHeader>

        <div class="grid grid-cols-3 gap-4">
            <!-- FORM -->
            <div class="flex flex-col bg-white p-4 mt-2 rounded-md">
                <div class="flex mb-2">
                    <h1 class="text-gray-600 font-semibold text-lg">Formulário Modelo:</h1>
                    <divxw v-if="loadingListForms" class="flex">
                        <svg class="animate-spin ml-1 mt-1 mr-3 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <small class="text-gray-400 font-light text-sm mt-1">Carregando...</small>
                    </divxw>
                </div>
                <h1 v-if="!form.uuid && loadingListForms" class="text-sm text-gray-400 font-light">Buscando...</h1>
                <SimpleTypeahead v-if="!route.params.form_uuid"
                    :disabled="loadingListForms"
                    ref="typeaheadRef2"
                    id="typeahead_id2"
                    placeholder="MegaForm"
                    :items="formOptions"
                    :itemProjection="form => form.title"
                    :minInputLength="1"
                    @selectItem="onSelectForm"
                ></SimpleTypeahead>
                <h1 class="text-green-600 font-bold text-xl">{{ form.name }}</h1>
            </div>
            <!-- EMPRESA -->
            <div class="bg-white mt-2 p-4">
                <div class="flex mb-2">
                    <h1 class="text-gray-600 font-semibold text-lg">Cliente:</h1>
                    <svg v-if="loadingCompanies" class="animate-spin ml-1 mt-1 mr-3 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
                <SimpleTypeahead
                    :disabled="loadingCompanies"
                    ref="typeaheadRef"
                    id="typeahead_id"
                    placeholder="Nome da Empresa"
                    :items="companies"
                    :itemProjection="company => company.title"
                    :minInputLength="1"
                    @selectItem="onSelectCompany"
                ></SimpleTypeahead>
            </div>
			<div class="bg-white mt-2 p-4">
				<div class="flex flex-col">
					<label class="label">Data de Competência</label>
					<Datepicker locale="pt-BR" :enableTimePicker="false" format="dd/MM/yyyy" v-model="competenceDate" autoApply />
				</div>
			</div>
        </div>

        <!-- Colaboradores -->
        <div class="w-full">
            <div class="flex flex-col bg-white p-4 mt-2 rounded-md">
                <div class="flex mb-2">
                    <div class="flex flex-col">
                        <h1 class="text-gray-600 font-semibold text-lg">Colaboradores Selecionados {{ totalSelected }}</h1>
                        <div class="flex items-center gap-3 mt-4 flex-wrap">
                            
                            <!-- Diretor -->
                            <div class="flex items-center gap-2">
                                <div class="w-3 h-3 rounded-sm bg-yellow-500"></div>
                                <span class="text-sm text-gray-600">CEO/Diretor</span>
                            </div>

                            <!-- Gerente -->
                            <div class="flex items-center gap-2">
                                <div class="w-3 h-3 rounded-sm bg-blue-500"></div>
                                <span class="text-sm text-gray-600">Gerente/Coord</span>
                            </div>

                            <!-- Colaborador -->
                            <div class="flex items-center gap-2">
                                <div class="w-3 h-3 rounded-sm bg-green-700"></div>
                                <span class="text-sm text-gray-600">Colaborador</span>
                            </div>
                        </div>

						<div v-if="selectedCompany && workers.length" class="flex gap-x-2 mt-4">
							<BaseCheckbox id="selectAll" @update:modelValue="toggleSelectAll" />
							<label class="text-base text-gray-600 font-semibold">Selecionar Todos</label>
						</div>
                        <hr class="mt-2">
                    </div>


                    <svg v-if="loadingWorkers" class="animate-spin ml-1 mt-1 mr-3 h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>

                <div v-if="!selectedCompany" class="flex gap-x-2 mt-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                    </svg>
                    <h1 class="text-gray-600 font-light text-sm">Selecione o cliente</h1>
                </div>

                <!-- Container com colunas verticais de altura fixa -->
				<div class="gap-4 w-full grid grid-cols-3">
					<!-- Bloco de cada colaborador -->
					<div v-for="worker in getOnlyBosses()" :key="worker.id" class="break-inside-avoid bg-white rounded shadow-sm">
						<div class="flex items-center gap-2">
							<BaseCheckbox id="checkBoxBoss" :checked="worker.selected" v-model="worker.selected" />
							<h1 :class="[
								'font-bold uppercase',
								worker.role === 'ceo' ? 'text-orange-500' :
								worker.role === 'director' ? 'text-yellow-500' :
								worker.role === 'manager' ? 'text-blue-500' :
								'text-green-700'
							]">
								{{ worker.name }}
								<small class="text-gray-400 text-sm font-light">
									({{ worker.targets?.length }})
								</small>
							</h1>
						</div>
						<!-- targets do boss -->
						<div v-for="target in worker.targets" :key="target.id" class="ml-4 mt-1 flex items-center gap-2 border-l pl-3">
							<BaseCheckbox :id="`worker-${target.id}`" v-model="target.selected" />
							<span class="uppercase font-medium"
								:class="[
									target.role==='manager' ? 'text-blue-600' :
									'text-green-700'
								]"
							>
								{{ target.name }}
							</span>
						</div>
					</div>
				</div>

                <div class="flex flex-col items-end">
                    <div v-if="!form.uuid" class="flex gap-x-2 mt-4">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-500">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                        </svg>
                        <h1 class="text-gray-600 font-light text-sm">Selecione o formulário</h1>
                    </div>
                    <BaseButton :disabled="!form.uuid" @click="send()" skin="primary-small">Enviar</BaseButton>
                </div>
            </div>
        </div>

        <div class="flex justify-center mb-6" v-if="loading">
            <Loading text="Buscando Dados  Aguarde..." :show="loading" />
        </div>

        <div class="bg-white p-4 rounded-md mt-2" v-if="!loading">
            <div class="flex mb-4">
                <h1 class="text-gray-600 font-bold text-xl">Histórico de Envios</h1>
            </div>
            <div class="grid grid-cols-5 mb-6 gap-x-4 card p-12" v-if="!loadingEntireScreen">
                <div class="flex flex-col">
                    <label class="label">Filtrar Data Inicial</label>
                    <Datepicker locale="pt-BR" :enableTimePicker="false" format="dd/MM/yyyy" v-model="filter.start_date" autoApply @update:modelValue="listDispatches(selectedCompany?.value)" />
                </div>
                <div class="flex flex-col">
                    <label class="label">Filtrar Data Final</label>
                    <Datepicker locale="pt-BR" :enableTimePicker="false" format="dd/MM/yyyy" v-model="filter.end_date" autoApply @update:modelValue="listDispatches(selectedCompany?.value)" />
                </div>
                <div class="mt-7">
                    <BaseButton :disabled="!selectedCompany" @click="listDispatches()" skin="primary-small">Atualizar</BaseButton>
                </div>
            </div>
            <Alert class="mt-4" text="Nenhum Envio" :show="!dispatches.length && !loadingDispatches" />

            <!-- Loading Skeleton-->
            <div v-if="loadingDispatches" class="mt-4 mx-auto w-full rounded-md p-4 mb-4">
                <div class="flex animate-pulse space-x-4">
                    <div class="size-10 rounded-full bg-gray-300"></div>
                    <div class="flex-1 space-y-6 py-1">
                    <div class="h-2 rounded bg-gray-300"></div>
                    <div class="space-y-3">
                        <div class="grid grid-cols-3 gap-4">
                        <div class="col-span-2 h-2 rounded bg-gray-300"></div>
                        <div class="col-span-1 h-2 rounded bg-gray-300"></div>
                        </div>
                        <div class="h-2 rounded bg-gray-300"></div>
                    </div>
                    </div>
                </div>
            </div>

            <table class="w-full" v-if="!loading && dispatches.length">
                <thead>
                    <tr>
                        <th class="text-left">#</th>
                        <th class="text-left">DATA/HORA</th>
                        <th class="text-left">TIPO</th>
                        <th class="text-left">RECEBEDOR</th>
                        <th class="text-left">COMPETÊNCIA:</th>
                        <th class="text-left">STATUS</th>
                        <th class="text-center">AÇÕES</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row border-t" v-for="(item, index) in dispatches" :key="item.id">
                        <td class="py-2">
                            <span class="text-sm text-green-700">{{ index + 1 }}</span>
                        </td>
                        <td class="py-2">
                            <span class="text-sm text-green-700">{{ dateTime(item.created_at) }}</span>
                        </td>
                        <td class="py-2">
							<span class="text-sm font-semibold text-gray-700 uppercase" v-if="item.type === 'pdi'">PDI</span>
                            <span class="text-sm font-semibold text-gray-700 uppercase" v-if="item.type === '360'">360</span>
							<span class="text-sm font-semibold text-gray-700 uppercase" v-if="item.type === 'climate'">Clima</span>
							<span class="text-sm font-semibold text-gray-700 uppercase" v-if="item.type === 'default'">Padrão</span>
							<span class="text-sm font-semibold text-gray-700 uppercase" v-if="item.type === 'presence'">Presença</span>
                        </td>
                        <td class="py-2">
                            <div class="flex flex-col">
                                <span class="text-sm font-bold text-green-800">{{ item.receiver?.name.slice(0, 20) }}</span>
                                <span class="text-xs text-gray-500">{{ item.receiver?.email }}</span>
                            </div>
                        </td>
                        <td class="py-2">
                            <span class="text-sm text-green-700">{{ defaultDate(item.competence_date) }}</span>
                        </td>
                        <td class="py-2">
                            <div class="flex gap-x-2">
                                <svg v-if="item.completed" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-green-600 w-5 bg-green-100">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12" />
                                </svg>
                                <span
                                    class="px-2 py-1 rounded text-xs font-medium"
                                    :class="{
                                        'bg-yellow-100 text-yellow-700': item.status === 'pending',
                                        'bg-green-100 text-green-700': item.status === 'sent',
                                        'bg-gray-500 text-white': item.status === 'canceled',
                                        'bg-green-500 text-white': item.status === 'done',
                                        'bg-red-100 text-red-700': item.status === 'error' || item.status === 'canceled'
                                    }">
                                    {{
                                        item.status === 'pending' ? 'Pendente' :
                                        item.status === 'sent' ? 'Enviado' :
                                        item.status === 'error' ? 'Erro' :
                                        item.status === 'done' ? 'Preenchido' :
                                        item.status === 'canceled' ? 'Cancelado' :
                                        item.status === 'canceled' ? 'Cancelado' : ''
                                    }}
                                </span>
                            </div>
                        </td>
                        <td class="py-2 text-center">
                            <div class="flex justify-center gap-x-4">
                                <!-- Visualizar -->
                                <svg @click="openInternalView(item.uuid)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 text-green-700 cursor-pointer">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                </svg>
                                
                                <!-- Copiar Link -->
                                <svg :class="{ 'bg-green-200 animate-fade rounded-full': copied }" @click="copyLink(item.url)" title="Copiar Link" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 text-green-700 cursor-pointer">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                </svg>

                                <!-- Reenviar-->
                                <svg v-if="item.status != 'pending'" @click="reSend(item.uuid)" title="Reenviar" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 text-green-700 cursor-pointer">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                                </svg>

                                <!-- Cancelar -->
                                <svg v-if="item.status == 'pending' || item.status == 'error'" @click="cancelDispatch(item.uuid)" title="Cancelar" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 text-green-700 cursor-pointer">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="flex justify-center">
                <PaginationV2
                    v-if="!loadingDispatches && dispatches.length"
                    class="mt-8"
                    :total="totalItens"
                    v-model="page"
                    :limit="limit"
                    @changePage="changePagination"
                />
            </div>
        </div>

    </div>
</template>

<script>
    import { ref, onMounted, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import Swal from 'sweetalert';
    import Alert from '@/components/Alert';
    import PaginationV2 from '@/components/PaginationV2';
    import UtilService from '../services/UtilService';
    import { dateTime } from '../filters/date';
    import { FormService, CompanyService, WorkerService, DispatchService } from '../services/Entity';
    import SimpleTypeahead from 'vue3-simple-typeahead';
    import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
    import { DateTime } from 'luxon';
	import { defaultDate } from '../filters/date';

    export default {
        name: 'Forms',
        components: {
            Alert,
            SimpleTypeahead,
            PaginationV2
        },
        setup() {
            const isEdit = ref(false);
            const page = ref(1);
            const limit = ref(50);
            const totalItens = ref(0);
            const pageHeader = ref('ENVIOS')
            const loading = ref(false);
            const selectedCompany = ref();
            const dispatches = ref([]);
            const dispatch = ref({});
            const route = useRoute();
            const router = useRouter();
            const form = ref({});
            const formOptions = ref([]);
            const loadingForm = ref(false);
            const loadingListForms = ref(false);
            const loadingCompanies = ref([]);
            const loadingWorkers = ref(false);
            const loadingDispatches = ref(false);
            const workers = ref([]);
            const companies = ref([]);
            const typeaheadRef = ref();
            const typeaheadRef2 = ref();
            const copied = ref(false);
			const totalSelected = ref(0);
            const filter = ref({
                start_date: DateTime.now().minus({ days: 30 }),
                end_date: DateTime.now() 
            });
			const competenceDate = ref(DateTime.now());

            onMounted(async () => {
                const formUUID = route.params.form_uuid;
                
                if (formUUID) {
                    loadingListForms.value = true;
                    form.value = await getFormByUUID(formUUID);
                    loadingListForms.value = false;
                } else {
                    const forms = await listForms();
                    
                    for (let item of forms) {
                        formOptions.value.push({
                            title: item.name,
                            value: item.uuid
                        });
                    }
                }

                const allCompanies = await listCompanies();

                for (let company of allCompanies) {
                    companies.value.push({
                        title: company.name,
                        value: company.id
                    });
                } 
            });

			watch(
				workers,
				() => {
					totalSelected.value = countSelectedUnique(workers.value);
				},
				{ deep: true }
			);

			function countSelectedUnique(workers) {
				const seen = new Set();
				let count = 0;

				function walk(list) {
					for (const w of list) {
						if (w.selected && !seen.has(w.id)) {
							count++;
							seen.add(w.id);
						}
						if (w.targets?.length) {
							walk(w.targets);
						}
					}
				}

				walk(workers);
				return count;
			}

			function countSelected(workers) {
				let count = 0;

				for (let worker of workers) {
					if (worker.selected) {
						count++;
					}

					if (worker.targets?.length) {
						for (let target of worker.targets) {
							if (target.selected) {
								count++;
							}
						}
					}
				}

				return count;
			}

            async function listForms(page = 1, limit = 100) {
                try {
                    loadingListForms.value = true;
                    const { data: { items } } = await FormService.list(page, limit);
                    loadingListForms.value = false;
                    
                    return items.filter(form => form.type !== 'pdi');
                } catch(err) {
                    loadingListForms.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function listCompanies(page = 1, limit = 9999) {
                try {
                    loadingCompanies.value = true;
                    const { data: { items } } = await CompanyService.list(page, limit, {});
                    loadingCompanies.value = false;

                    return items;
                } catch(err) {
                    loadingCompanies.value = false;
                    loading.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro ao obter dados dos clientes',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function getFormByUUID(uuid) {
                try {
                    loadingForm.value = true;
                    const { data } = await FormService.getById(uuid);
                    loadingForm.value = false;
                    
                    return data;
                } catch(err) {
                    loadingForm.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function listDispatches(companyId) {
                try {
                    loadingDispatches.value = true;

                    const start = filter.value.start_date
                        ? DateTime.fromJSDate(new Date(filter.value.start_date)).toISODate()
                        : null;

                    const end = filter.value.end_date
                        ? DateTime.fromJSDate(new Date(filter.value.end_date)).toISODate()
                        : null;

                    const { data: { items, total } } = await DispatchService.list(
	page.value,
                        limit.value,
                        {
                            company: companyId,
                            start_date: start,
                            end_date: end
                        }
                    );

                    dispatches.value = items;
                    totalItens.value = total;

                    loadingDispatches.value = false;
                    return items;
                } catch (err) {
                    loadingDispatches.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro ao carregar os envios',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function listWorkers(companyId) {
                try {
                    loadingWorkers.value = true;
                    const { data } = await WorkerService.list(companyId);
                    loadingWorkers.value = false;
                    
                    return sortWorkersHierarchy(data);
                } catch(err) {
                    loadingForm.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function onSelectCompany(company) {
                if (!company || !company.value) {
                    return;
                }

                selectedCompany.value = company;
                page.value = 1;
                dispatches.value = await listDispatches(selectedCompany.value?.value);
                workers.value = await listWorkers(company.value);
            }

            async function onSelectForm(selectedForm) {
                loadingListForms.value = true;
                form.value = await getFormByUUID(selectedForm.value);
                loadingListForms.value = false;
            }

            function bossHasBoss(workerId) {
                const bossId = findClosestBossId(workerId);
                const superiorBossId = findClosestBossId(bossId);

                return superiorBossId ? true : false;
            }

            function findClosestBossId(workerId) {
                const index = workers.value.findIndex(w => w.id === workerId);
                if (index === -1) return null;

                const target = workers.value[index];
                const bossIds = target.boss || [];
                if (bossIds.length === 0) return null;

                for (let i = index - 1; i >= 0; i--) {
                    if (bossIds.includes(workers.value[i].id)) {
                        return workers.value[i].id;
                    }
                }

                return null;
            }

            function getOnlyBosses() {
				return workers.value.filter(worker => {
					const hasSubordinates = Array.isArray(worker.targets) && worker.targets.length > 0;
					const isTopLevel = Array.isArray(worker.boss) ? worker.boss.length === 0 : !worker.boss;

					return hasSubordinates || isTopLevel;
				});
            }

            function sortWorkersHierarchy(workers) {
                const idToWorkerMap = {};
                const rolePriority = {
                    ceo: 1,
                    director: 2,
                    manager: 3,
                    worker: 4
                };

                // Mapa por ID e init de targets vazios
                workers.forEach(worker => {
                    idToWorkerMap[worker.id] = { ...worker, targets: [], selected: false };
                });

                // Preencher targets (1 nível apenas)
                workers.forEach(worker => {
					const bossId = worker.boss?.[0];
					if (bossId && idToWorkerMap[bossId]) {
						idToWorkerMap[bossId].targets.push(idToWorkerMap[worker.id]); // mesma referência ✅
					}
				});

                // Gerar lista ordenada
                const sorted = Object.values(idToWorkerMap).sort((a, b) => {
                    const roleA = rolePriority[a.role] || 99;
                    const roleB = rolePriority[b.role] || 99;
                    return roleA - roleB;
                });

                return sorted;
            }

            async function send() {
                try {
					const chosenWorkers = workers.value.filter(worker => worker.selected);

					if (!chosenWorkers.length) {
						Swal({
							title: 'Selecione os Colaboradores',
							icon: 'info'
						});
						return;
					}

                    Swal({
                        title: 'Deseja realmente colocar na fila para envio?',
                        icon: 'info',
                        buttons: {
                            cancel: 'Cancelar',
                            confirm: {
                                text: 'Sim',
                                className: 'swal-button--info'
                            }
                        },
                        dangerMode: false
                    }).then(async (confirm) => {
                        if (confirm) {
                            if (!confirm) return;

							const selectedCompetenceDate = normalizeToISO(competenceDate.value);

                            const selectedWorkers = workers.value.filter(worker => worker.selected);

                            if (!selectedWorkers.length) {
                                Swal({
                                    title: 'Nenhum colaborador selecionado',
                                    text: 'Selecione pelo menos um colaborador',
                                    icon: 'warning'
                                });
                                return;
                            }

                            const dispatcheList = [];
							const groupUUID = UtilService.generateUUID();

							for (const worker of selectedWorkers) {
								let personalizedForm;
								if (form.value.form_body?.type === '360') {
									// só gera estrutura personalizada se for 360
									personalizedForm = generate360StructureMultiple(
										form.value.form_body,
										selectedWorkers
									);
								} else {
									// caso contrário, usa o form original
									personalizedForm = form.value.form_body;
								}

								dispatcheList.push({
									type: form.value.form_body?.type,
									form_structure: JSON.stringify(personalizedForm),
									receiver: worker.id,
									method: 'email',
									company: selectedCompany.value?.value,
									uuid: UtilService.generateUUID(),
									group_uuid: groupUUID,
									competence_date: selectedCompetenceDate
								});
							}

                            if (!dispatcheList.length) {
                                Swal({
                                    title: 'Nenhum colaborador selecionado',
                                    text: 'Não há liderados para os líderes escolhidos.',
                                    icon: 'info'
                                });
                                return;
                            }

                            // Envia para o backend
                            loadingDispatches.value = true;
                            const { data } = await DispatchService.createBulk(dispatcheList);
                            loadingDispatches.value = false;

                            Swal({
                                title: 'Adicionado à fila com sucesso',
                                icon: 'success'
                            });

                            // Atualize a lista de dispatches se necessário
                            dispatches.value = [...data, ...dispatches.value];
                        }
                    });
                } catch(err) {
                    loadingDispatches.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

			function normalizeToISO(date) {
				if (!date) return null;

				if (date instanceof Date) {
					return DateTime.fromJSDate(date).toISODate();
				}

				if (DateTime.isDateTime(date)) {
					return date.toISODate();
				}

				return null;
			}

			function generate360StructureMultiple(formBody, workers) {
				const newForm = JSON.parse(JSON.stringify(formBody));

				const baseStructure = newForm.structure;
				const expandedStructure = [];

				for (const worker of workers) {
					const personalizedFields = baseStructure.map(field => {
						const newField = JSON.parse(JSON.stringify(field)); // cópia do campo

						// Substitui FULANO(a) por nome do avaliado
						if (newField.label?.includes('FULANO')) {
							newField.label = newField.label.replace('FULANO(a)', worker.name);
						}

						// Zera respostas
						if (newField.options) {
							newField.options = newField.options.map(opt => ({ ...opt, answer: '' }));
						} else {
							newField.answer = '';
						}

						console.log(worker.id);
						newField.target_worker_id = worker.id;

						// Garante UUID único (se quiser evitar colisão)
						newField.uuid = UtilService.generateUUID();

						return newField;
					});

					expandedStructure.push(...personalizedFields);
				}

				newForm.structure = expandedStructure;
				return newForm;
			}

            async function changePagination(newPage) {
                page.value = newPage;
                await listDispatches(selectedCompany.value?.value);
            }

            function copyLink(url) {
                UtilService.copyToClipboard(url);
                copied.value = true;

                setTimeout(() => {
                    copied.value = false;
                }, 2000);
            }

            function openInternalView(uuid) {
                const routeData = router.resolve({ name: 'surveyinternal', params: { dispatch_uuid: uuid } });
                window.open(routeData.href, '_blank');
            }

            async function reSend(uuid) {
                Swal({
                    title: 'Tem certeza que deseja reenviar por email?',
                    text: 'O sistema tentará fazer o reenvio',
                    icon: 'info',
                    buttons: {
                        cancel: 'Cancelar',
                        confirm: {
                            text: 'Reenviar',
                            className: 'swal-button--info'
                        }
                    },
                    dangerMode: false
                }).then(async (confirm) => {
                    if (confirm) {
                        loadingDispatches.value = true;
                        await DispatchService.update(uuid, { status: 'pending', is_valid: true, is_completed: false });
                        await listDispatches();
                        loadingDispatches.value = false;
                    }
                });
            }

            async function cancelDispatch(uuid) {
                Swal({
                    title: 'Tem certeza que deseja cancelar o envio?',
                    text: 'Depois de cancelar, você ainda pode reenviar no botão ao lado',
                    icon: 'warning',
                    buttons: {
                        cancel: 'Voltar',
                        confirm: {
                            text: 'Cancelar',
                            className: 'swal-button--danger'
                        }
                    },
                    dangerMode: true
                }).then(async (confirm) => {
                    if (confirm) {
                        loadingDispatches.value = true;
                        await DispatchService.update(uuid, { status: 'canceled', is_valid: false, is_completed: false });
                        await listDispatches();
                        loadingDispatches.value = false;
                    }
                });
            }

			function toggleSelectAll(isChecked) {
				for (let worker of workers.value) {
					worker.selected = isChecked ? true : false;
				}
			}

            return {
				defaultDate,
				competenceDate,
				totalSelected,
				toggleSelectAll,
                reSend,
                cancelDispatch,
                openInternalView,
                copyLink,
                copied,
                UtilService,
                changePagination,
                filter,
                loadingDispatches,
                listDispatches,
                send,
                selectedCompany,
                bossHasBoss,
                loadingWorkers,
                route,
                workers,
                onSelectForm,
                onSelectCompany,
                form,
                loadingListForms,
                loadingForm,
                dispatches,
                isEdit,
                page,
                limit,
                totalItens,
                loading,
                pageHeader,
                dateTime,
                dispatch,
                formOptions,
                typeaheadRef,
                typeaheadRef2,
                loadingCompanies,
                companies,
                getOnlyBosses
            }
        }
    }

</script>

<style>
#typeahead_id.simple-typeahead-input {
	padding: 0.5rem 0.75rem;
	border: 1px solid #d1d5db; /* gray-300 */
	border-radius: 0.5rem;     /* rounded-lg */
	width: 100%;
	font-size: 1rem;
	color: #374151;            /* text-gray-700 */
	background-color: white;
}

#typeahead_id.simple-typeahead-input:focus {
	outline: none;
	border-color: #60a5fa;     /* blue-400 */
	box-shadow: 0 0 0 1px #60a5fa;
}
</style>
